import { concat, hash } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';
import gt from 'ember-truth-helpers/helpers/gt';
import or from 'ember-truth-helpers/helpers/or';
import bioExamResultsCountAdhocResults from 'parog-web/helpers/bio-exam-results/count-adhoc-results';
import bioExamResultsFileAttachmentsDesc from 'parog-web/helpers/bio-exam-results/file-attachments-desc';
import type BioExamResultsReceivedJournalEvent from 'parog-web/models/bio-exam-results-received-journal-event';
import type Patient from 'parog-web/models/patient';
import type SemeiaSessionService from 'parog-web/services/session';
import fuiPopup from 'wise-fui-modules/modifiers/fui-popup';
interface Signature {
  Args: {
    journalEvent: BioExamResultsReceivedJournalEvent;
    patient?: Patient;
  };
}

export default class FileAttachmentsCellComponent extends Component<Signature> {
  @service declare session: SemeiaSessionService;

  get creatorName(): string {
    return this.args.journalEvent.creator?.name || '';
  }

  get hlaRoute(): string {
    return this.session.patient
      ? 'patient-web.protected.hla.consult'
      : 'medics-web.protected.patients.patient.hla.consult';
  }

  <template>
    {{#if
      (or
        @journalEvent.fileAttachmentsWithoutZip
        @journalEvent.isFromExternalSource
      )
    }}
      {{#if @journalEvent.hlaId}}
        <LinkTo
          @route={{this.hlaRoute}}
          @model={{@journalEvent}}
          data-test-download-file={{@journalEvent.id}}
        >
          <div class='flex items-center justify-center'>
            Résultats HLA
          </div>
        </LinkTo>
      {{else}}
        {{#if this.session.medic}}
          <LinkTo
            @route='medics-web.protected.patients.patient.bio-results.edition'
            @model={{@patient}}
            @query={{hash sourceJeId=@journalEvent.id}}
            data-test-download-file={{@journalEvent.id}}
          >
            <div class='flex items-center justify-center'>
              {{bioExamResultsFileAttachmentsDesc @journalEvent}}
            </div>
          </LinkTo>
        {{else}}
          <LinkTo
            @route='patient-web.protected.bio-results.edition'
            @query={{hash sourceJeId=@journalEvent.id}}
            data-test-download-file={{@journalEvent.id}}
          >
            <div class='flex items-center justify-center'>
              {{bioExamResultsFileAttachmentsDesc @journalEvent}}
            </div>
          </LinkTo>
        {{/if}}
      {{/if}}
    {{/if}}

    {{#if (gt (bioExamResultsCountAdhocResults @journalEvent) 0)}}
      <div data-test-count-adhoc-results>
        <span class='placeholder-label'>
          {{t
            'bioExamResultCodes.unknownResults'
            count=(bioExamResultsCountAdhocResults @journalEvent)
          }}
        </span>
      </div>
    {{/if}}
    <div
      data-test-status={{@journalEvent.validationStatus}}
      {{fuiPopup inline=true position='top center'}}
    >
      <span class='ui inverted black text'>
        <i class='question circle icon hover:text-grey text-[#80808066]'></i>
      </span>
    </div>
    <div class='ui popup'>
      <div class='content'>
        {{t
          (concat 'bioExamResultsStatus.' @journalEvent.validationStatus)
          name=this.creatorName
        }}
      </div>
    </div>
  </template>
}
